import {
  widgetClose,
  widgetOpen,
  isMobile,
  isIOS,
  fixedBodyStyleAddAll,
  fixedBodyStyleRemoveAll,
  updateCatalogOverflowState,
} from '../../../resources/scripts/components/c-common';
import destinationSearch from '../../../resources/scripts/components/c-destination';

destinationSearch();

function controlOpen(el) {
  const container = el.querySelector('.js-hotel-search-control-container');
  container.classList.add('open');
}

function controlClose(el) {
  const container = el.querySelector('.js-hotel-search-control-container');
  container.classList.remove('open');
}

function addLink(el, link) {
  const buttonLink = el.querySelector('.js-hotel-search-control-link');
  buttonLink.style.display = 'flex';
  buttonLink.href = link;
}

function controlCloseAll(el) {
  const containers = el.querySelectorAll('.js-hotel-search-control-container');
  containers.forEach((container) => {
    container.classList.remove('open');
  });
}

const widget = window.document.querySelector('.js-hotel-search');

const SCROLL_LOCK_OWNER = 'hotel-search';

function hotelSearchBackdropAdd() {
  const hotelSearch = window.document.querySelector('.hotel-search');
  if (hotelSearch) {
    hotelSearch.classList.add('backdrop');
  }

  const header = window.document.querySelector('.header');
  if (header) {
    header.classList.remove('header--visible');
  }

  if (isMobile()) {
    fixedBodyStyleAddAll(SCROLL_LOCK_OWNER);
    if (isIOS && hotelSearch) {
      const input = hotelSearch.querySelector('input[type="text"], input[type="search"]');
      if (input) {
        input.focus({ preventScroll: true });
      }
    }
  }
}

function hotelSearchBackdropRemove() {
  const hotelSearch = window.document.querySelector('.hotel-search');
  if (hotelSearch) {
    hotelSearch.classList.remove('backdrop');
  }
  fixedBodyStyleRemoveAll(SCROLL_LOCK_OWNER);
}

function closeHotelSearchWidget() {
  const controls = window.document.querySelectorAll('.js-hotel-search-control');
  const hasOpenControls = Array.from(controls).some((control) => control.querySelector('.js-hotel-search-control-container.open'));
  const isWidgetOpen = widget && widget.classList.contains('open');

  if (hasOpenControls || isWidgetOpen) {
    controls.forEach((control) => {
      widgetClose(widget);
      controlClose(control);
    });
    if (isMobile()) {
      hotelSearchBackdropRemove();
    }
  }
}

const hotelSearchWidget = window.document.querySelector('.js-hotel-search');
if (hotelSearchWidget) {
  const destinationProperties = hotelSearchWidget.querySelectorAll('.js-destination-property');
  destinationProperties.forEach((property) => {
    property.addEventListener('click', (event) => {
      event.preventDefault();
      const { target } = event;
      const control = target.closest('.js-hotel-search-control');
      if (!control) return;
      const trigger = control.querySelector('.js-hotel-search-control-trigger');
      if (trigger) {
        trigger.textContent = target.textContent.trim();
      }
      const link = property.href;
      if (link) {
        addLink(control, link);
      }
      controlClose(control);
      widgetClose(widget);
      if (isMobile()) {
        hotelSearchBackdropRemove();
      }
      updateCatalogOverflowState(hotelSearchWidget, '.js-hotel-search-control-container');
    });
  });
}

document.addEventListener('click', (event) => {
  const { target } = event;

  if (target.classList.contains('js-control-back')
    || target.closest('.js-control-back')) {
    const control = target.closest('.js-hotel-search-control');
    if (control) {
      controlClose(control);
      widgetClose(widget);
      if (isMobile()) {
        hotelSearchBackdropRemove();
      }
    }
  }
});

const controlTriggers = document.querySelectorAll('.js-hotel-search-control-trigger');
controlTriggers.forEach((trigger) => {
  function openSelect(event) {
    const { target } = event;
    const control = target.closest('.js-hotel-search-control');
    const dataInput = target.dataset.input;
    const input = control.querySelector(`.${dataInput}`);
    controlCloseAll(widget);
    controlOpen(control);

    if (!isIOS || !isMobile()) {
      input.focus({ preventScroll: true });
    }

    if (!widget.classList.contains('open')) {
      widgetOpen(widget);
    }
    if (isMobile()) {
      hotelSearchBackdropAdd();
    }

    updateCatalogOverflowState(widget, '.js-hotel-search-control-container');
  }

  trigger.addEventListener('click', openSelect);

  trigger.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openSelect(event);
    }
  });
});

window.document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeHotelSearchWidget();
  }
});

window.document.addEventListener('click', (event) => {
  const { target } = event;
  const closest = target.closest('.js-hotel-search-control, .js-hotel-search-widget');
  if (closest === null) {
    closeHotelSearchWidget();
  }
});

// iOS ignores html overflow:hidden, so while the widget is open touch scrolling
// is only allowed inside its own scrollable lists.
if (isIOS) {
  document.addEventListener('touchmove', (e) => {
    const hotelSearch = window.document.querySelector('.hotel-search');
    if (hotelSearch && hotelSearch.classList.contains('backdrop')) {
      const controlContainer = e.target.closest('.c-control__container');
      const catalogContainer = e.target.closest('.c-destination__catalog-container');

      if (catalogContainer && !catalogContainer.classList.contains('no-scroll')) {
        const canScroll = catalogContainer.scrollHeight > catalogContainer.clientHeight;
        if (canScroll) {
          return;
        }
      }

      if (controlContainer && !controlContainer.classList.contains('no-scroll')) {
        const canScroll = controlContainer.scrollHeight > controlContainer.clientHeight;
        if (canScroll) {
          return;
        }
      }

      e.preventDefault();
    }
  }, { passive: false });
}

window.addEventListener('resize', () => {
  const openedControl = window.document.querySelector('.js-hotel-search-control-container.open');

  if (!isMobile()) {
    hotelSearchBackdropRemove();
  }

  if (!openedControl) {
    widgetClose(widget);
    if (isMobile()) {
      hotelSearchBackdropRemove();
    }
  } else if (widget.classList.contains('open') && isMobile()) {
    hotelSearchBackdropAdd();
  }

  updateCatalogOverflowState(widget, '.js-hotel-search-control-container');
});

document.addEventListener('input', (event) => {
  const { target } = event;
  if (target && target.classList && target.classList.contains('js-catalog-search')) {
    updateCatalogOverflowState(widget, '.js-hotel-search-control-container');
  }
});
